// @flow
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import ChoosePlan from './ChoosePlan'
import type { PropsType, DispatchPropsType } from './ChoosePlan'
import type { AppStateType } from '../../../reducers/appstate'
import { changePlanAction } from '../../../actions/subscriptionActions'

type OwnPropsType = {
  header?: string,
  subHeader?: string
}

const mapStateToProps = (state: AppStateType, ownProps: OwnPropsType): any => {
  return ({
    subHeader: ownProps.subHeader,
    textAnnualArialLabel: state.textAnnualArialLabel,
    textMonthlyCtaWebApp: state.textMonthlyCtaWebApp,
    textMonthlyArialLabel: state.textMonthlyArialLabel,
    plan: (state.subscriptionPurchase || {}).plan,
    promoValid: (state.subscriptionPromo || {}).valid,
    promoText: (state.subscriptionText || {}).promoText,
    promoPlan: (state.subscriptionText || {}).plan,
    crossOutText: (state.subscriptionText || {}).crossOutText,
    badgeText: (state.subscriptionText || {}).badgeText,
    planChosen: !!(state.subscriptionText || {}).plan,
    price: (state.subscriptionText || {}).price,
    annualBilledText: (state.subscriptionText || {}).annualBilledText,
    subscriptionPromoText: (state.subscriptionText || {}).subscriptionPromoText,
    featureAnnualOnly: state.featureAnnualOnly,
    annualPriceText: state.subscriptionText.annualPriceText
  }: PropsType)
}

const mapDispatchToProps = (dispatch: Dispatch<any>): any => {
  return ({
    choosePlan: (plan: 'monthly' | 'annual'): void => dispatch(changePlanAction(plan))
  }: DispatchPropsType)
}

export default connect<PropsType & DispatchPropsType, OwnPropsType, _, _, _, _>(mapStateToProps, mapDispatchToProps)(ChoosePlan)
